import * as types from './mutation-types'
import api from './api'
import cookies from 'cookiesjs'

const actions = {

  loginUser({ commit }, payload) {
    // Reset me promise (used in user.getLoggedUser action)
    commit(types.RESET_ME_PROMISE)
    
    cookies({ accountType: 'EMPLOYEE' })
    return api.login(payload)
      .then(response => {
        // console.log(response.data)
        commit(types.LOGIN_SUCCESS, payload)
      }, error => {
        commit(types.LOGIN_FAILURE)
      })
  },

  logoutUser({ commit }) {
    return api.logout()
      .then(_ => commit(types.LOGOUT))
  },

  fetchAgenciesList({ commit }) {
    return api.fetchAgencies()
      .then(response => commit(types.AGENCIES_RECEIVED, response.data.agencies))
  },

  fetchOrganizationsList({ commit }) {
    return api.fetchOrganizations()
      .then(response => commit(types.ORGANIZATIONS_RECEIVED, response.data.organizations))
  },

  fetchSapPromoCodesList({ commit }) {
    return api.fetchSapPromoCodes()
      .then(response => commit(types.SAP_PROMO_CODES_RECEIVED, response.data.sap_promo_codes))
  }
}

export default actions



// WEBPACK FOOTER //
// ./client/store/actions.js